// extracted by mini-css-extract-plugin
export default {"ul":"ul__lMH8l"};